"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _styles = require("../shared/styles");

var _loading = _interopRequireDefault(require("../loading"));

var _ = _interopRequireDefault(require("../.."));

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.InfoText, {}, void 0, "Entre com o seu celular. Enviaremos o c\xF3digo de acesso no seu WhatsApp");

var _ref3 =
/*#__PURE__*/
(0, _jsx2["default"])(_loading["default"], {});

var Phone =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Phone, _Component);

  function Phone(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Phone);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Phone).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "phoneInput", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyPressed", function (_ref) {
      var keyCode = _ref.keyCode;

      if (keyCode === 13) {
        _this.onSubmit();

        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changePhone", function (event) {
      var value = event.target.value;

      if (_this.state.errorMessage) {
        _this.setState({
          errorMessage: null
        });
      }

      _this.setState({
        phone: value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearPhone", function (phone) {
      var charsToClean = [' ', '(', ')', '-', '_'];
      var newPhone = phone;
      charsToClean.forEach(function (_char) {
        newPhone = newPhone.split(_char).join('');
      });
      return newPhone;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "requestToken", function (phone) {
      _this.setState({
        isLoading: true
      });

      _this.props.requestToken(phone).then(function () {
        return _this.props.goToStep(_["default"].STEP_NAMES.token);
      })["catch"](function () {
        return _this.setState({
          isLoading: false,
          errorMessage: Phone.ERROR_MESSAGES.apiError
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", function () {
      if (_this.state.errorMessage) {
        _this.setState({
          errorMessage: null
        });
      }

      var cleanPhone = _this.clearPhone(_this.state.phone);

      if (cleanPhone.length !== 11) {
        _this.setState({
          errorMessage: Phone.ERROR_MESSAGES.invalidPhone
        });
      } else {
        _this.requestToken(cleanPhone);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isButtonDisabled", function () {
      return _this.clearPhone(_this.state.phone).length !== 11;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderForm", function () {
      return (0, _jsx2["default"])(_Row["default"], {
        flexDirection: "column"
      }, void 0, (0, _jsx2["default"])(_styles.TitleText, {
        color: "pink"
      }, void 0, _this.props.title), _this.props.renderInfo() || _ref2, (0, _jsx2["default"])(_reactInputMask["default"], {
        mask: "(99) 99999-9999",
        value: _this.state.phone,
        onChange: _this.changePhone,
        onKeyDown: _this.onKeyPressed
      }, void 0, _react["default"].createElement(_styles.CenterInput, {
        height: "medium",
        mt: "16px",
        mb: 2,
        pattern: "\\d*",
        inputMode: "numeric",
        placeholder: "(11) 99999-9999",
        hideLabelView: true,
        error: _this.state.errorMessage,
        ref: _this.phoneInput
      })), (0, _jsx2["default"])(_styles.CTAButton, {
        fluid: true,
        active: true,
        onClick: _this.onSubmit,
        disabled: _this.isButtonDisabled()
      }, void 0, "Entrar"));
    });
    _this.state = {
      phone: props.phone,
      errorMessage: null,
      isLoading: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Phone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.phoneInput.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.isLoading ? _ref3 : this.renderForm();
    }
  }]);
  return Phone;
}(_react.Component);

(0, _defineProperty2["default"])(Phone, "ERROR_MESSAGES", {
  invalidPhone: 'Por favor, entre com um número de telefone válido',
  apiError: 'Ocorreu um erro! Por favor, tente novamente!'
});
Phone.propTypes = {
  requestToken: _propTypes["default"].func.isRequired,
  goToStep: _propTypes["default"].func.isRequired,
  phone: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  renderInfo: _propTypes["default"].func.isRequired
};
var _default = Phone;
exports["default"] = _default;